/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Login_Required_ToastInputs */

const en_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must be logged in to purchase a subscription`)
};

const fr_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous devez etre connecte pour acheter un abonnement`)
};

const de_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie müssen angemeldet sein, um ein Abonnement zu erwerben.`)
};

const it_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devi aver effettuato l'accesso per acquistare un abbonamento`)
};

const ru_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для приобретения подписки необходимо войти в систему.`)
};

const es_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes iniciar sesión para comprar una suscripción.`)
};

const zh_cn2_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您必须登录才能购买订阅`)
};

const ja_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションを購入するにはログインする必要があります`)
};

const hi_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता खरीदने के लिए आपको लॉग इन करना होगा।`)
};

const pt_pt2_signup_login_required_toast = /** @type {(inputs: Signup_Login_Required_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você precisa estar conectado para comprar uma assinatura.`)
};

/**
* | output |
* | --- |
* | "You must be logged in to purchase a subscription" |
*
* @param {Signup_Login_Required_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_login_required_toast = /** @type {((inputs?: Signup_Login_Required_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Login_Required_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_login_required_toast(inputs)
	if (locale === "de") return de_signup_login_required_toast(inputs)
	if (locale === "it") return it_signup_login_required_toast(inputs)
	if (locale === "ru") return ru_signup_login_required_toast(inputs)
	if (locale === "es") return es_signup_login_required_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_login_required_toast(inputs)
	if (locale === "ja") return ja_signup_login_required_toast(inputs)
	if (locale === "hi") return hi_signup_login_required_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_login_required_toast(inputs)
	return en_signup_login_required_toast(inputs)
});